export const AA_SUPPORT_TYPES = [
  { value: "understand", label: "Help me understand something" },
  { value: "organize_next_steps", label: "Help me organize next steps" },
  { value: "prepare_school", label: "Help me prepare for a school conversation" },
  { value: "funding_documents", label: "Help me think through funding or documents" },
  { value: "draft_message", label: "Help me draft a message" },
  { value: "share_what_happened", label: "I just need to share what happened" },
  { value: "share_win", label: "I want to share a small win" },
  { value: "not_sure", label: "I'm not sure" },
];

export const AA_CATEGORIES = [
  { value: "funding_tax_credits", label: "Funding or tax credits" },
  { value: "disability_tax_credit", label: "Disability Tax Credit" },
  { value: "ontario_autism_program", label: "Ontario Autism Program / provincial support" },
  { value: "school_support", label: "School support" },
  { value: "documents_applications", label: "Documents or applications" },
  { value: "service_providers", label: "Service providers" },
  { value: "therapy_care_team", label: "Therapy or care team questions" },
  { value: "family_routines", label: "Family routines" },
  { value: "emotional_support", label: "Emotional support / tough day" },
  { value: "small_win", label: "Small win / celebration" },
  { value: "other", label: "Other" },
];

export const AA_INTERNAL_STATUSES = [
  { value: "new", label: "New" },
  { value: "assigned", label: "Assigned" },
  { value: "drafting", label: "Drafting" },
  { value: "waiting_on_user", label: "Waiting on user" },
  { value: "sent", label: "Sent" },
  { value: "closed", label: "Closed" },
  { value: "safety_flagged", label: "Safety flagged" },
];

export const AA_ADMIN_QUEUES = [
  { value: "open", label: "Open" },
  { value: "new", label: "New" },
  { value: "assigned", label: "Assigned" },
  { value: "drafting", label: "Drafting" },
  { value: "waiting_on_user", label: "Waiting on user" },
  { value: "sent", label: "Sent" },
  { value: "safety_flagged", label: "Safety flagged" },
  { value: "closed", label: "Closed" },
];

export const aaLabel = (list, v) => list.find((o) => o.value === v)?.label || v;

export const AA_SLA_STYLE = {
  on_track: { label: "On track", cls: "bg-kid-skytint text-kid-teal" },
  due_soon: { label: "Due soon", cls: "bg-kid-sun/20 text-[#B07A11]" },
  overdue: { label: "Overdue", cls: "bg-kid-coral/15 text-kid-coral" },
  responded: { label: "Responded", cls: "bg-kid-green/15 text-[#3f9d5c]" },
  closed: { label: "Closed", cls: "bg-kid-mist text-kid-muted" },
};

export const AA_STATUS_STYLE = {
  "Sent to KidPath": "bg-kid-skytint text-kid-teal",
  "We're reviewing this": "bg-kid-skytint text-kid-teal",
  "We're preparing a reply": "bg-kid-sun/20 text-[#B07A11]",
  "Waiting for your reply": "bg-kid-sun/20 text-[#B07A11]",
  "KidPath replied": "bg-kid-green/15 text-[#3f9d5c]",
  "Closed": "bg-kid-mist text-kid-muted",
  "Needs urgent attention outside KidPath": "bg-kid-coral/15 text-kid-coral",
};

export const AA_DISCLAIMER = "KidPath provides general information and organization support only. KidPath does not provide medical, clinical, legal, tax, financial, government, crisis, or funding eligibility advice. KidPath does not determine eligibility, diagnose, provide treatment advice, complete applications, or guarantee outcomes.";

export const AA_CRISIS = "KidPath is not an emergency or crisis service, and Ask Anything is not monitored in real time. If there is immediate danger or you are worried about someone's safety, contact emergency services or a qualified crisis support service right away.";
